export function SimplePreview(): JSX.Element {
  return (
    <div className="appearance-preview preview-simple">
      <i />
      <div>
        <b />
        <section>
          <span />
          <span />
        </section>
        <span />
        <span />
      </div>
    </div>
  );
}
